$(document).ready(function() {
    const account = {
        isLoadingInfo: false,
        isLoadingPasswordInfo: false,
        isLoadingEmail: false,
        init() {
            $(document).on('click', '#user-page-save-details', this, this.updatePersonalInfo);
            $(document).on('click', '#update-password', this, this.updatePassword);
            $(document).on('click', '#emails-preferences-save', this, this.updateEmailPreferences);
            $(document).on('click', '.cancel-reservation', this, this.cancelReservation);

            $('#country_id').select2();
        },
        updateEmailPreferences(event) {
			const _this = event.data;

            if (_this.isLoadingEmail) {
                return false;
            }

			//Loading...
            _this.isLoadingEmail = true;

			var values = '_token=' + $('#_token_email').val();
            values += '&newsletter=' + ($('#newsletter').is(":checked")?1:0);
            values += '&promotions=' + ($('#promotions').is(":checked")?1:0);

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/update-email-preferences`,
                data: values,
                beforeSend: function() {
                    _this.isLoadingEmail = true;
                },
                complete: function() {
                    _this.isLoadingEmail = false;
                },
                success: function(response, xhr) {
                    _this.isLoadingEmail = false;

                    if (response.status == 1) {
                        $('#emails-preferences-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>'+response.message+'</p>');
						return false;
                    }

					$('#emails-preferences-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>'+response.message+'</p>');
                },
                error(error) {
                    _this.isLoadingEmail = false;
                    $('#emails-preferences-notifications').html('<p><i class="fa fa-check-circle" aria-hidden="true"></i>Error: Something went wrong please contact an administrator!</p>');
                },
            });

		},
        updatePersonalInfo(event) {
            const _this = event.data;

            if (_this.isLoadingInfo) {
                return false;
            }

			$('#profile-notifications').html();
            $('#profile-form').find('.is-invalid').removeClass('is-invalid');

            //Loading...
            _this.isLoadingInfo = true;
            var element = this;
            $(element).find('i').show();

            var values = '_token=' + $('#_token_profile').val();
            values += '&email=' + $('#email').val();
            values += '&phone=' + $('#phone').val();
            values += '&first_name=' + $('#first_name').val();
            values += '&last_name=' + $('#last_name').val();
            values += '&date_of_birth=' + $('#date_of_birth').val();
            values += '&country_id=' + $('#country_id option:selected').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/update-info `,
                data: values,
                beforeSend: function() {
                    _this.isLoadingInfo = true;
                    $(element).find('i').show();
                },
                complete: function() {
                    _this.isLoadingInfo = false;
                    $(element).find('i').hide();
                },
                success: function(response, xhr) {
                    _this.isLoadingInfo = false;
                    $(element).find('i').hide();

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).addClass('is-invalid');
                            }
                        }

                        $('#profile-notifications').html('<div class="alert alert-danger" role="alert">'+response.message+'</div>');
                        return false;
                    }

                    if (response.status == 1) {
                        $('#profile-notifications').html('<div class="alert alert-success" role="alert">'+response.message+'</div>');
						return false;
                    }

					$('#profile-notifications').html('<div class="alert alert-danger" role="alert">'+response.message+'</div>');
                },
                error(error) {
                    _this.isLoadingInfo = false;
                    $(element).find('i').hide();
					$('#profile-notifications').html('<div class="alert alert-danger" role="alert">Error: Something went wrong please contact an administrator!</div>');
                },
            });
        },
        updatePassword(event) {
            const _this = event.data;

            if (_this.isLoadingPasswordInfo) {
                return false;
            }

			$('#password-notifications').html();
            $('#password-form').find('.is-invalid').removeClass('is-invalid');

            //Loading...
            _this.isLoadingPasswordInfo = true;
            var element = this;
            $(element).find('i').show();

            var values = '_token=' + $('#_token_password').val();
            values += '&old_password=' + $('#old_password').val();
            values += '&new_password=' + $('#new_password').val();
            values += '&new_password_confirmation=' + $('#new_password_confirmation').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/update-password `,
                data: values,
                beforeSend: function() {
                    _this.isLoadingPasswordInfo = true;
                    $(element).find('i').show();
                },
                complete: function() {
                    _this.isLoadingPasswordInfo = false;
                    $(element).find('i').hide();
                },
                success: function(response, xhr) {
                    _this.isLoadingPasswordInfo = false;
                    $(element).find('i').hide();

                    if (response.status == 0) {
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).addClass('is-invalid');
                            }
                        }

                        $('#password-notifications').html('<div class="alert alert-danger" role="alert">'+response.message+'</div>');
                        return false;
                    }

                    if (response.status == 1) {

						$('#old_password').val('');
						$('#new_password').val('');
						$('#new_password_confirmation').val('');

                        $('#password-notifications').html('<div class="alert alert-success" role="alert">'+response.message+'</div>');
						return false;
                    }

					$('#password-notifications').html('<div class="alert alert-danger" role="alert">'+response.message+'</div>');
                },
                error(error) {
                    _this.isLoadingPasswordInfo = false;
                    $(element).find('i').hide();
                    $('#password-notifications').html('<div class="alert alert-danger" role="alert">Error: Something went wrong please contact an administrator!</div>');
                },
            });
        },
		cancelReservation(event) {
			let id = $(this).data('id');
			let alertText = $(this).data('alert-text');
			let link = this;

			if (confirm(alertText)) {
				var values = '_token=' + $('#_token_reservation').val();
	            values += '&id=' + id;

	            $.ajax({
	                type: "POST",
	                url: `${baseURL}/account/reservations/cancel`,
	                data: values,
	                beforeSend: function() {},
	                complete: function() {},
	                success: function(response, xhr) {

	                    if (response.status == 1) {
							$('.reservation-status').html(response.data);
							$(link).remove();
	                        alert(response.message);
							return false;
	                    }

						alert(response.message);
	                },
	                error(error) {
	                    alert('Error: Something went wrong please contact an administrator!');
	                },
	            });
			}
		},
    };

    if ($('.account-section').length || $('.my-order-details').length) {
        account.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/account.js